<template>
  <div v-if="status === 'pending'" class="pt-14">
    <div class="flex w-full flex-row flex-wrap items-center justify-center py-5 md:flex-nowrap md:justify-between">
      <div class="inline-flex w-full flex-nowrap justify-center py-3"><UiSkeleton class="h-60 w-40" /></div>
      <div class="inline-flex w-full flex-nowrap justify-center py-3"><UiSkeleton class="h-60 w-40" /></div>
      <div class="inline-flex w-full flex-nowrap justify-center py-3"><UiSkeleton class="h-60 w-40" /></div>
      <div class="inline-flex w-full flex-nowrap justify-center py-3"><UiSkeleton class="h-60 w-40" /></div>
    </div>
    <UiDivider />
    <div class="flex w-full flex-row flex-wrap items-center justify-center py-5 md:flex-nowrap">
      <div class="inline-flex w-full flex-nowrap justify-center py-3"><UiSkeleton class="h-28 w-40" /></div>
      <div class="inline-flex w-full flex-nowrap justify-center py-3"><UiSkeleton class="h-28 w-40" /></div>
      <div class="inline-flex flex-nowrap justify-center py-3 md:w-full"><UiSkeleton class="h-28 w-40" /></div>
    </div>
    <div
      class="flex w-full flex-row flex-wrap items-center justify-center bg-primary-500 px-8 py-5 md:flex-nowrap md:justify-between md:py-2"
    >
      <div class="flex flex-row flex-nowrap py-3">
        <UiSkeleton class="h-6 w-40" />
      </div>
      <div class="flex flex-col md:flex-row md:flex-nowrap">
        <div class="py-3 md:mr-8"><UiSkeleton class="h-6 w-40" /></div>
        <div class="py-3"><UiSkeleton class="h-6 w-40" /></div>
      </div>
    </div>
  </div>
  <footer v-else class="bg-neutral-50 pt-14">
    <FooterSection v-if="cmsStore.footer?.sections.length" />
    <UiDivider />
    <FooterContact v-if="cmsStore.footer?.contacts.length" />
    <FooterCopyright />
  </footer>
</template>

<script setup lang="ts">
import type { Locale } from '~/utils/common';

import { useCmsStore } from '~/stores/cms/cmsStore';

const { locale } = useI18n();

const cmsStore = useCmsStore();

const asyncData = await useAsyncData('footer', async () => {
  if (!cmsStore.footer) return await cmsStore.fetchFooter(locale.value as Locale);

  return cmsStore.footer;
});

const { status } = asyncData;

watch([locale], () => asyncData.refresh());
</script>
